import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "./authinterceptor";
import AuthHeader from "../services/auth.header";


export const submitCart = createAsyncThunk('cart/submitCart', async (args, thunkApi) => {
  console.log("IN SUBMIT CART");
  try {
    const state = thunkApi.getState();
    const items = [];
    state.cart.cartItems.map(item => {
      console.log("ITEM", item);
      //let idx = parseInt(item.sizeIdx);

      items.push({
        sizeId: item.product.sizeId,
        sizeName: item.sizeName,
        colorName: item.colorName,
        price: item.price,
        quantity: item.quantity,
        productId: item.product.id
      })
      return item;
    });

    const response = await axios.post(process.env.REACT_APP_API_URL + "/submitorder",
      {
        "orderId": state.cart.currentOrder.id,
        "paymentType": args.paymentType
      },
      { headers: AuthHeader.authHeader() });
    console.log("ORDER RESPONSE", response);
    return response.data;
  } catch (error) {
    console.log("SUBMIT ORDER ERROR", error);
  }
});

export const submitCCPayment = createAsyncThunk('cart/submitCCPayment', async (args, { getState }) => {
  console.log("IN SUBMIT CC PAYMENT", args);
  const response = await axios.post(process.env.REACT_APP_API_URL + "/submitcc",
    {
      token: args.token,
      amount: args.amount,
      shipping: args.shipping,
      "orderId": args.orderId,
      "paymentType": "cc",
      "balanceUsed": args.balanceUsed
    },
    { headers: AuthHeader.authHeader() });
  console.log("ORDER RESPONSE", response);
  return response.data;
});

export const createOrder = createAsyncThunk('cart/createOrder', async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/createorder", { headers: AuthHeader.authHeader() });
  return response.data;
});

export const getCurrentOrder = createAsyncThunk('cart/getCurrentOrder', async (order, thunkApi) => {
  console.log("GETTING CURRENT ORDER");
  const response = await axios.get(process.env.REACT_APP_API_URL + "/currentorder", { headers: AuthHeader.authHeaderFromState(thunkApi.getState()) });
  console.log("GETTING CURRENT ORDER ", response);
  return response.data;
});

export const addItemToOrder = createAsyncThunk('cart/addItemToOrder', async (item, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/additemtoorder",
    {
      "item": item,
      "order": thunkApi.getState().cart.currentOrder
    },
    { headers: AuthHeader.authHeader() });
  console.log("Add Item to Order RESPONSE", response);
  return response.data;

});

export const addKitToOrder = createAsyncThunk('cart/addKitToOrder', async (items, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/addkittoorder",
    {
      "items": items,
      "order": thunkApi.getState().cart.currentOrder
    },
    { headers: AuthHeader.authHeader() });
  console.log("Add Kit to Order RESPONSE", response);
  return response.data;

});

export const addPrintItemToOrder = createAsyncThunk('cart/addPrintItemToOrder', async (args, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/addprintitemtoorder",
    {
      "item": args.item,
      "order": thunkApi.getState().cart.currentOrder
    },
    { headers: AuthHeader.authHeader() });
  console.log("Add Print Item to Order RESPONSE", response);
  return response.data;
});


export const removeItemFromOrder = createAsyncThunk('cart/removeItemFromOrder', async (itemId, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/removeitemfromorder",
    { "itemId": itemId },
    { headers: AuthHeader.authHeader() });
  console.log("Remove Item to Order RESPONSE", response);
  return itemId;
});

export const clearOrder = createAsyncThunk('cart/clearOrder', async (itemId, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/clearorder",
    { "order": thunkApi.getState().cart.currentOrder },
    { headers: AuthHeader.authHeader() });
  console.log("Clear Order RESPONSE", response);
  return response.data;
});

export const updateItemQuantity = createAsyncThunk('cart/updateItemQuantity', async (args, thunkApi) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/updateiteminorder",
    {
      "itemId": args.item.id,
      "quantity": args.quantity
    },
    { headers: AuthHeader.authHeader() });
  console.log("Update items in order", response);
  return {
    "itemId": args.item.id,
    "quantity": args.quantity
  };
});



export const cart = state => state.cart.cartItems;
export const showCart = state => state.cart.showCart;
export const cartCount = state => state.cart.cartCount;
export const submittedOrder = state => state.cart.submittedOrder;
export const currentOrder = state => state.cart.currentOrder;
export const updatedBalance = state => state.cart.updatedBalance;
export const submitCCStatus = state => state.cart.submitCCStatus;
export const submitStatus = state => state.cart.submitStatus;
export const submitError = state => state.cart.error;


const initialState = {
  cartItems: [],
  currentOrder: {},
  submittedOrder: [],
  cartCount: 0,
  status: 'idle',
  submitStatus: 'idle',
  submitCCStatus: 'idle',
  createStatus: 'idle',
  currentOrderStatus: 'idle',
  addItemToOrderStatus: 'idle',
  removeItemFromOrderStatus: 'idle',
  updateItemToOrderStatus: 'idle',
  updatedBalance: 0,
  error: null,
  showCart: false
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart(state, action) {
      state.cartItems.push(action.payload);
      var count = 0;
      for (var i = 0; i < state.cartItems.length; i++) {
        count += state.cartItems[i].quantity;
      }
      state.cartCount = count;
      console.log("CART COUNT", state.cartCount);
    },
    clearCart(state, action) {
      state.cartItems = [];
      state.cartCount = 0;
    },
    removeFromCart(state, action) {
      console.log("CART ITEMS", state.cartItems);
      for (var i = 0; i < state.cartItems.length; i++) {
        var item = state.cartItems[i];
        if (item.product.id === action.payload) {
          state.cartItems.splice(i, 1);
          break;
        }
      };
      var count = 0;
      for (i = 0; i < state.cartItems.length; i++) {
        count += state.cartItems[i].quantity;
      }
      state.cartCount = count;
    },
    toggleShowCart(state, action) {
      state.showCart = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(submitCart.pending, (state, action) => {
        state.submitStatus = 'loading'
      })
      .addCase(submitCart.fulfilled, (state, action) => {
        state.submitStatus = 'succeeded'
        console.log("ADD TO CATALOG ARRAY", action.payload);
        state.submittedOrder = action.payload;
        state.submittedOrder.items = state.cartItems;
        state.updatedBalance = action.newBalance;
        state.cartItems = [];
        state.cartCount = 0;
      })
      .addCase(submitCart.rejected, (state, action) => {
        state.submitStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(createOrder.pending, (state, action) => {
        state.createStatus = 'loading'
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.createStatus = 'succeeded'
        console.log("CREATE ORDER", action.payload);
        state.currentOrder = action.payload;
        if (action.payload.order_items) {
          state.cartItems = action.payload.order_items;
          var count = 0;
          for (var i = 0; i < state.cartItems.length; i++) {
            count += state.cartItems[i].quantity;
          }
          state.cartCount = count;
        } else {
          state.cartItems = [];
          state.cartCount = 0;
        }
        state.submitCCStatus = 'idle';
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.createStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(getCurrentOrder.pending, (state, action) => {
        console.log("CURRENT ORDER LOADING");
        state.currentOrderStatus = 'loading'
      })
      .addCase(getCurrentOrder.fulfilled, (state, action) => {
        state.currentOrderStatus = 'succeeded'
        console.log("CURRENT ORDER", action.payload);
        state.currentOrder = action.payload;
        if (action.payload.order_items) {
          state.cartItems = action.payload.order_items;
          var count = 0;
          for (var i = 0; i < state.cartItems.length; i++) {
            count += state.cartItems[i].quantity;
          }
          state.cartCount = count;
        } else {
          state.cartItems = [];
          state.cartCount = 0;
        }
        state.submitCCStatus = 'idle';
      })
      .addCase(getCurrentOrder.rejected, (state, action) => {
        console.log("CURRENT ORDER FAILED", action.error.message);
        state.currentOrderStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(addItemToOrder.pending, (state, action) => {
        console.log("ADD ITEM TO ORDER LOADING");
        state.addItemToOrderStatus = 'loading'
      })
      .addCase(addItemToOrder.fulfilled, (state, action) => {
        state.addItemToOrderStatus = 'succeeded';
        console.log("ADD ITEM TO ORDER", action.payload);
        action.payload.orderitem.decorations = action.payload.decorations;
        state.cartItems.push(action.payload.orderitem);
        var count = 0;
        for (var i = 0; i < state.cartItems.length; i++) {
          count += state.cartItems[i].quantity;
        }
        state.cartCount = count;
      })
      .addCase(addItemToOrder.rejected, (state, action) => {
        console.log("ADD ITEM TO ORDER FAILED", action.error.message);
        state.addItemToOrderStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(addKitToOrder.pending, (state, action) => {
        console.log("ADD KIT TO ORDER LOADING");
        state.addItemToOrderStatus = 'loading';
        state.error = "";
      })
      .addCase(addKitToOrder.fulfilled, (state, action) => {
        state.addItemToOrderStatus = 'succeeded';
        console.log("ADD ITEM TO ORDER", action.payload);
        state.cartItems = [];
        //action.payload.orderitem.decorations = action.payload.decorations;
        for (var i = 0; i < action.payload.orderitems.length; i++) {
          action.payload.orderitems[i].decorations = action.payload.decorations[i];
          state.cartItems.push(action.payload.orderitems[i]);
        }
        state.cartCount = 0;
        state.error = "";
      })
      .addCase(addKitToOrder.rejected, (state, action) => {
        console.log("ADD KIT TO ORDER FAILED", action.error);
        state.addItemToOrderStatus = 'failed';
        state.error = "Insufficient Funds";

      })
      .addCase(addPrintItemToOrder.pending, (state, action) => {
        state.addItemToOrderStatus = 'loading';
        state.error = "";
      })
      .addCase(addPrintItemToOrder.fulfilled, (state, action) => {
        state.addItemToOrderStatus = 'succeeded';
        const oi = action.payload.orderitem;
        oi.print_item = action.payload.printItem;
        oi.decorations = [];
        state.cartItems.push(oi);
        var count = 0;
        for (var i = 0; i < state.cartItems.length; i++) {
          count += state.cartItems[i].quantity;
        }
        state.cartCount = count;
        state.error = "";
      })
      .addCase(addPrintItemToOrder.rejected, (state, action) => {
        console.log("ADD PRINT ITEM TO ORDER FAILED", action.error);
        state.addItemToOrderStatus = 'failed';
        state.error = action.error.message || "Failed to add print item";
      })
      .addCase(submitCCPayment.pending, (state, action) => {
        console.log("CURRENT ORDER LOADING");
        state.submitCCStatus = 'loading'
      })
      .addCase(submitCCPayment.fulfilled, (state, action) => {
        state.submitCCStatus = 'succeeded'
        //state.ccresult = action.payload;
        state.submittedOrder = action.payload;
        state.submittedOrder.items = state.cartItems;
        state.updatedBalance = action.newBalance;
        state.cartItems = [];
        state.cartCount = 0;
      })
      .addCase(submitCCPayment.rejected, (state, action) => {
        console.log("SUBMIT CC FAILED", action.error.message);
        state.submitCCStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(updateItemQuantity.pending, (state, action) => {
        console.log("UPDATE QUANTITY");
        state.updateItemToOrderStatus = 'loading';
      })
      .addCase(updateItemQuantity.fulfilled, (state, action) => {
        state.updateItemToOrderStatus = 'succeeded'
        console.log("UPDATE ITEMS IN ORDER", action.payload);
        for (var i = 0; i < state.cartItems.length; i++) {
          if (state.cartItems[i].id === action.payload.itemId) {
            state.cartItems[i].quantity = action.payload.quantity;
            break;
          }
        }
        var count = 0;
        for (i = 0; i < state.cartItems.length; i++) {
          count += state.cartItems[i].quantity;
        }
        state.cartCount = count;
      })
      .addCase(updateItemQuantity.rejected, (state, action) => {
        console.log("UPDATE QUANTITY", action.error.message);
        state.updateItemToOrderStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(removeItemFromOrder.pending, (state, action) => {
        console.log("REMOVE ITEM");
        state.removeItemFromOrderStatus = 'loading'
      })
      .addCase(removeItemFromOrder.fulfilled, (state, action) => {
        state.removeItemFromOrderStatus = 'succeeded'
        console.log("REMOVE ITEMS FROM ORDER", action.payload);
        for (var i = 0; i < state.cartItems.length; i++) {
          var item = state.cartItems[i];
          if (item.id === action.payload) {
            state.cartItems.splice(i, 1);
            break;
          }
        };
        var count = 0;
        for (i = 0; i < state.cartItems.length; i++) {
          count += state.cartItems[i].quantity;
        }
        state.cartCount = count;
      })
      .addCase(removeItemFromOrder.rejected, (state, action) => {
        console.log("REMOVE ERROR", action.error.message);
        state.removeItemFromOrderStatus = 'failed'
        state.error = action.error.message
      })
      .addCase(clearOrder.pending, (state, action) => {
        console.log("CLEAR ORDER");
        state.removeItemFromOrderStatus = 'loading'
      })
      .addCase(clearOrder.fulfilled, (state, action) => {
        console.log("CLEAR ORDER", action.payload);
        state.cartItems = [];
        state.cartCount = 0;
      })
      .addCase(clearOrder.rejected, (state, action) => {
        console.log("REMOVE ERROR", action.error.message);
        state.removeItemFromOrderStatus = 'failed'
        state.error = action.error.message
      })
  }
});

export const { addToCart, clearCart, removeFromCart, toggleShowCart } = cartSlice.actions;
export default cartSlice.reducer;


